import * as slugify from 'slugify';
import {
	__,
	add,
	all,
	any,
	append,
	assoc,
	equals,
	filter,
	find,
	findIndex,
	flatten,
	forEach,
	has,
	includes,
	isNil,
	keys,
	length,
	map,
	not,
	pipe,
	pluck,
	prop,
	propEq,
	reduce,
	reject,
	sort,
	tail,
	values,
	without,
} from 'ramda';

export const diff = (a, b) => a.localeCompare(b);

export const getSlugify = value => slugify(value, {
	lower: true,
	remove: /[^\w\s]/gi,
});

export const addUuidName = factor => assoc('uuid', getSlugify(factor.name), factor);

export const getFactorIdsToCompare = (factor, combinations) => pipe(
	() => filter(item => has(factor.uuid, item), combinations || []),
	map(keys),
	flatten,
	without(factor.uuid, __),
)(factor);

export const getFactorCombinations = (factor, combinations) => filter(
	item => has(factor.uuid, item),
	combinations || [],
);

export const factorWeighingCompletedCount = (factor, combinations) => pipe(
	factorItem => getFactorCombinations(factorItem, combinations),
	filter(item => all(x => !isNil(x), values(item))),
	length,
)(factor);

export const factorWeighingIsCompleted = (factor, combinations) => equals(
	factorWeighingCompletedCount(factor, combinations),
	length(getFactorCombinations(factor, combinations)),
);

export const combinationsAreFilled = combinations => pipe(
	map(values),
	flatten,
	any(isNil),
	not,
)(combinations);

export const factorWeighingSum = (factor, combinations) => pipe(
	() => pluck(factor.uuid, combinations || []),
	reject(isNil),
	reduce(add, 0),
)(factor);

export const totalSumWeighings = combinations => pipe(
	map(values),
	flatten,
	reject(isNil),
	reduce(add, 0),
)(combinations);

export const getPercentageByValue = (value, total) => {
	if (total > 0) { return ((value * 100) / total).toFixed(0); }
	return 0;
};

export const getPercentageValue = (percentage, total) => {
	if (total > 0) { return ((percentage * total) / 100).toFixed(0); }
	return 0;
};

export const factorIsSelected = (selectedFactors, factor) => !isNil(find(propEq('uuid', factor.uuid), selectedFactors));

const existCombination = (combination, combinationList) => {
	const foundIndex = findIndex(
		combinationItem => equals(
			sort(diff, keys(combination)),
			sort(diff, keys(combinationItem)),
		),
		combinationList,
	);
	return foundIndex > 0;
};

export const generateWeighingComparison = (selectedList) => {
	let combinationList = [];
	forEach(
		(factor) => {
			forEach(
				(compareFactor) => {
					const factorUuid = prop('uuid', factor);
					const compareFactorUuid = prop('uuid', compareFactor);
					if (factorUuid !== compareFactorUuid) {
						const combination = pipe(
							assoc(factorUuid, null),
							assoc(compareFactorUuid, null),
						)({});
						if (!existCombination(combination, combinationList)) {
							combinationList = append(combination, combinationList);
						}
					}
				},
				tail(selectedList),
			);
		},
		selectedList,
	);
	return combinationList;
};

export const getFactorsToCompare = (factor, combinations, selectedFactors) => {
	const factorToCompareIds = getFactorIdsToCompare(factor, combinations);
	return filter(
		factorItem => (
			includes(factorItem.uuid, factorToCompareIds) &&
			!factorWeighingIsCompleted(factorItem, combinations)
		),
		selectedFactors,
	);
};

export const addWeighWith = (selectedFactors, combinations) => {
	const findElement = (uuid) => {
		const foundIndex = findIndex(propEq('uuid', uuid), selectedFactors);
		return prop(foundIndex, selectedFactors);
	};

	let restCombinations = combinations;
	return map((factor) => {
		const newFactor = assoc(
			'weighWith',
			pipe(
				filter(has(factor.uuid)),
				map(keys),
				flatten,
				reject(equals(__, factor.uuid)),
				map(
					(factorUuid) => {
						const element = findElement(factorUuid);
						return {
							name: element.name,
							uuid: element.uuid,
							urlImage: element.urlImage,
						};
					},
				),
			)(restCombinations),
			factor,
		);
		restCombinations = reject(has(factor.uuid), restCombinations);
		return newFactor;
	}, selectedFactors);
};

export default {};




// WEBPACK FOOTER //
// ./src/modules/job-evaluation/utils/valuation-model/factors.js